export enum OrderTypeEnum {
    ACTUAL = 'actual',
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}
